function getClientAppVersion() {
  return localStorage.getItem('APP_VERSION') ?? 0;
}

function setClientAppVersion(version) {
  return localStorage.setItem('APP_VERSION', version);
}

export default ({ app }) => {
  app.router.afterEach((to, from) => {
    const clientStoredVersion = getClientAppVersion();
    const buildTimestamp = process?.env?.buildTimestamp || '_';

    if (!clientStoredVersion) {
      setClientAppVersion(buildTimestamp);
      return;
    }
    if (clientStoredVersion != buildTimestamp) {
      window.location.reload(true);
      setClientAppVersion(buildTimestamp);
    }
  });
};
